import { useModalState } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { formatCentsAsUsd } from "@src/appV2/lib/Money/utils/currency";
import { useCurrentDate } from "@src/appV2/lib/utils/useCurrentDate";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { addHours, hoursToMilliseconds } from "date-fns";
import { useEffect, useMemo } from "react";

import { useUnseenBonusPayments } from "../hooks/useUnseenBonusPayments";
import { BonusPaymentSheet } from "./BonusPaymentSheet";

export function OnCallBonusPaymentSheet() {
  const worker = useDefinedWorker();

  // Update the time every hour
  const currentDate = useCurrentDate(hoursToMilliseconds(1));
  const startDate = useMemo(() => addHours(currentDate, -24), [currentDate]);

  // Get bonus payments for on-call shifts
  const { unseenBonusPayments, markBonusPaymentAsSeen } = useUnseenBonusPayments("onCall", {
    workerId: worker?.userId,
    status: ["PAID"],
    reason: ["On call shift worked with no offers"],
    startDate,
    options: { enabled: isDefined(worker) },
  });

  const onCallBonusPaymentModalState = useModalState();

  useEffect(() => {
    if (unseenBonusPayments.length > 0 && onCallBonusPaymentModalState.modalIsClosed) {
      onCallBonusPaymentModalState.openModal();
    }
  }, [unseenBonusPayments, onCallBonusPaymentModalState]);

  const amountInMinorUnits = unseenBonusPayments[0]?.attributes.amountInMinorUnits;
  const title = isDefined(amountInMinorUnits)
    ? `You just got paid ${formatCentsAsUsd(amountInMinorUnits)}!`
    : "You just got paid!";

  return (
    <BonusPaymentSheet
      modalState={onCallBonusPaymentModalState}
      title={title}
      description="Thanks for booking on-call. We couldn’t find you any shifts today but your commitment is appreciated!"
      onClose={() => {
        markBonusPaymentAsSeen(unseenBonusPayments[0]?.id);
      }}
    />
  );
}
